import React from 'react';
import { useTranslation } from 'react-i18next';
import { IMAGES } from '../layout/theme';
import { Award, Clock, Languages, MapPin } from 'lucide-react';

const features = [
    { icon: Award,     key: 'professionalService', gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' },
    { icon: Clock,     key: 'availability247',     gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' },
    { icon: Languages, key: 'multilingualTeam',    gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)' },
    { icon: MapPin,    key: 'localExpertise',      gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)' },
];

const AboutUsContent = () => {
    const { t } = useTranslation();

    return (
        <div className="container">
            {/* Hero — text left, image right */}
            <div className="about-hero">
                <div className="about-hero-text">
                    <span className="sub-title">{t('aboutUsContent.subtitle')}</span>
                    <h2 className="h2-title">{t('aboutUsContent.title')}</h2>
                    <p>{t('aboutUsContent.description1')}</p>
                    <p>{t('aboutUsContent.description2')}</p>
                </div>
                <div className="about-hero-img">
                    <img src={IMAGES.doorSecure} alt="Property Management" />
                </div>
            </div>

            {/* Why Choose Us */}
            <div className="center-title">
                <h2 className="h2-title">{t('aboutUsContent.whyChoose')}</h2>
            </div>

            <div className="about-features-grid">
                {features.map((f) => {
                    const Icon = f.icon;
                    return (
                        <div className="about-feature-card" key={f.key}>
                            <div className="about-feature-icon" style={{ background: f.gradient }}>
                                <Icon size={34} color="#fff" strokeWidth={2.5} />
                            </div>
                            <h4>{t(`aboutUsContent.${f.key}`)}</h4>
                            <p>{t(`aboutUsContent.${f.key}Desc`)}</p>
                        </div>
                    );
                })}
            </div>

            {/* Mission & Vision — side by side */}
            <div className="about-mv-row">
                <div className="about-mv-card">
                    <h3>{t('aboutUsContent.ourMission')}</h3>
                    <p>{t('aboutUsContent.ourMissionDesc')}</p>
                </div>
                <div className="about-mv-card vision">
                    <h3>{t('aboutUsContent.ourVision')}</h3>
                    <p>{t('aboutUsContent.ourVisionDesc')}</p>
                </div>
            </div>
        </div>
    );
};

export default AboutUsContent;